import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-tag-version',
    templateUrl: './tag-version.component.html',
    styleUrls: ['./tag-version.component.scss'],
    standalone: false
})
export class TagVersionComponent implements OnInit {

  public tagVersion = [];
  public valid = true;

  constructor(
    public dialogRef: MatDialogRef<TagVersionComponent>,
  ) {
  }

  ngOnInit() {
  }

  public createTag(tagversion) {
    if (!tagversion || tagversion.length !== 3) {
      this.valid = false;
      return false;
    }
    for (let i = 0; i < 3; i++) {
      if (/[\D]/.test(tagversion[i])) {
        this.valid = false;
        return;
      }
    }
    const version = [];
    version.push(tagversion[0] + '.' + tagversion[1] + '.' + tagversion[2]);
    version.push(tagversion[0] + '.' + tagversion[1] + '.*');
    version.push(tagversion[0] + '.*');
    return version;

  }

  save() {
    const version = this.createTag(this.tagVersion);
    if (version) {
      this.dialogRef.close({
        tagVersion: version
      });
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
